import { APPLICATION_STATUS } from '../constants/variables';

export const getColorStatusApplication = (status) =>
  Object.values(APPLICATION_STATUS).find(({ label }) => label === status)?.color;
